export default {
  'menu.admin.mailbox': 'Mailbox',
  'menu.mailbox': 'Mailbox',
  'mailbox.empty.no_accounts': 'No mailbox has been set up yet.',
  'mailbox.empty.go_configure': 'Set up a mailbox',

  'mailbox.field.name': 'Name',
  'mailbox.field.email': 'Email',
  'mailbox.field.provider': 'Provider',
  'mailbox.field.auth_type': 'Authentication',
  'mailbox.field.secret': 'App password',
  'mailbox.auth.oauth_google': 'Sign in with Google',
  'mailbox.auth.oauth_microsoft': 'Sign in with Microsoft',
  'mailbox.auth.password': 'App password (IMAP)',
  'mailbox.delete': 'Delete',
  'mailbox.delete_confirm':
    'Delete this mailbox? It stops collecting mail. Messages already collected stay in the inbox.',
  'mailbox.change_secret': 'Change password',
  'mailbox.will_authorize': 'You will be asked to sign in after the mailbox is created.',
  'mailbox.secret_help':
    'The app-specific password / authorization code from your mail provider — not your login password.',
  'mailbox.field.since_days': 'Backfill window',
  'mailbox.since_days_value': '{days} days',
  'mailbox.since_days_help':
    'How far back the first collection reaches. Later collections follow the UID cursor and are not limited by this. A mailbox that has been in use for a while needs a wider window, or its existing mail falls outside it and nothing is collected.',
  'mailbox.collected_none_first_run':
    'Nothing collected. This mailbox has never been collected from, and the first run only reaches back {days} days — if its mail is older than that, widen the backfill window and collect again.',
  'mailbox.field.folder': 'Folder',
  'mailbox.field.username': 'IMAP login',
  'mailbox.username_help':
    'Usually the same as the mailbox address. For a shared mailbox this is the mailbox being read, while the authorization belongs to another account.',
  'mailbox.field.authorized': 'Authorized',
  'mailbox.field.last_collected': 'Last collected',
  'mailbox.disabled': 'Paused',
  'mailbox.disabled_notice':
    'This mailbox is paused. No new mail is collected and nothing here is processed; already collected mail stays readable. Re-enable it in Admin › Mailbox.',
  'mailbox.field.enabled': 'Enabled',
  'mailbox.field.from': 'From',
  'mailbox.field.to': 'To',
  'mailbox.field.subject': 'Subject',
  'mailbox.field.sent_at': 'Sent at',
  'mailbox.field.attachments': 'Attachments',
  'mailbox.field.status': 'Status',

  'mailbox.status.all': 'All',
  'mailbox.restore': 'Restore',
  'mailbox.ignore': 'Ignore',
  'mailbox.status.new': 'To review',
  'mailbox.status.ignored': 'Ignored',

  'mailbox.add_account': 'Add mailbox',
  'mailbox.edit_account': 'Edit mailbox',
  'mailbox.edit_immutable_help':
    'The mailbox address, provider and authentication method cannot be changed after the mailbox is created — switching them would invalidate the stored credentials and the sync cursor. Create a new mailbox instead. To replace the password, use Change password.',
  'mailbox.authorize': 'Authorize',
  'mailbox.reauthorize': 'Re-authorize',
  'mailbox.authorized': 'Mailbox authorized',
  'mailbox.not_authorized': 'Not authorized',
  'mailbox.test': 'Test',
  'mailbox.testing': 'Testing connection…',
  'mailbox.test_ok': 'Connection OK',
  'mailbox.messages_total': 'messages in folder',
  'mailbox.collect_now': 'Collect now',
  'mailbox.collecting': 'Collecting…',
  'mailbox.collected': 'New messages collected',
  'mailbox.attachment_unnamed': '(unnamed file)',
  'mailbox.no_subject': '(no subject)',
  'mailbox.has_errors': 'Some mailboxes need attention',
  'mailbox.created_now_authorize': 'Mailbox created — click Authorize to connect it',
  'mailbox.email_help':
    'The shared mailbox to collect from. The account you authorize with must have Full Access to it.',

  'mailbox.field.participants': 'People',
  'mailbox.field.last_activity': 'Last activity',
  'mailbox.thread.count': '{count} messages',
  'mailbox.thread.partial':
    'Only {count} of this thread’s {total} messages match the current filter; the rest are under other labels or tabs.',
  'mailbox.thread.selected': '{threads} threads / {messages} messages selected',
  'mailbox.thread.empty': 'No threads match',
  'mailbox.field.labels': 'Labels',
  'mailbox.field.default_labels': 'Default labels',
  'mailbox.default_labels_help':
    'AI adds these labels to every mail collected from this mailbox. A label starts its flow, for example pre-alert suggestions, as if someone had added it.',
  'mailbox.label_add': 'Label',
  'mailbox.filter_by_label': 'Filter by label',
  'mailbox.add_label_to_selected': 'Add label',
  'mailbox.remove_label': 'Remove label…',
};
